/**
 * Professional Shipping Calculator JavaScript
 * Modern dropdown-based shipping cost calculator with real-time calculations
 * Version: 2.0.0
 */

(function() {
  'use strict';

  // Comprehensive shipping rates database
  const shippingRates = {
    // K-Packet rates (Economy shipping 3-6 weeks)
    kpacket: {
      zones: {
        'Hong Kong': { zone: 'zone1', korean: '홍콩' },
        'Taiwan': { zone: 'zone2', korean: '대만' },
        'Japan': { zone: 'zone3', korean: '일본' },
        'Thailand': { zone: 'zone4', korean: '태국' },
        'Philippines': { zone: 'zone5', korean: '필리핀' },
        'Singapore': { zone: 'zone6', korean: '싱가포르' },
        'Indonesia': { zone: 'zone7', korean: '인도네시아' },
        'Malaysia': { zone: 'zone8', korean: '말레이시아' },
        'Vietnam': { zone: 'zone9', korean: '베트남' }
      },
      rates: {
        zone1: [ // Hong Kong
          { maxWeight: 0.1, price: 4160 },
          { maxWeight: 0.2, price: 5250 },
          { maxWeight: 0.3, price: 6340 },
          { maxWeight: 0.4, price: 7420 },
          { maxWeight: 0.5, price: 8540 },
          { maxWeight: 0.6, price: 9410 },
          { maxWeight: 0.7, price: 10280 },
          { maxWeight: 0.8, price: 11140 },
          { maxWeight: 0.9, price: 12010 },
          { maxWeight: 1.0, price: 12890 },
          { maxWeight: 1.5, price: 16770 },
          { maxWeight: 2.0, price: 19100 }
        ],
        zone2: [ // Taiwan
          { maxWeight: 0.1, price: 4530 },
          { maxWeight: 0.2, price: 5860 },
          { maxWeight: 0.3, price: 7190 },
          { maxWeight: 0.4, price: 8520 },
          { maxWeight: 0.5, price: 9880 },
          { maxWeight: 0.6, price: 10990 },
          { maxWeight: 0.7, price: 12090 },
          { maxWeight: 0.8, price: 13190 },
          { maxWeight: 0.9, price: 14300 },
          { maxWeight: 1.0, price: 15410 },
          { maxWeight: 1.5, price: 20450 },
          { maxWeight: 2.0, price: 23870 }
        ],
        zone3: [ // Japan
          { maxWeight: 0.1, price: 4590 },
          { maxWeight: 0.2, price: 5810 },
          { maxWeight: 0.3, price: 7050 },
          { maxWeight: 0.4, price: 8280 },
          { maxWeight: 0.5, price: 9540 },
          { maxWeight: 0.6, price: 10530 },
          { maxWeight: 0.7, price: 11520 },
          { maxWeight: 0.8, price: 12510 },
          { maxWeight: 0.9, price: 13490 },
          { maxWeight: 1.0, price: 14490 },
          { maxWeight: 1.5, price: 18930 },
          { maxWeight: 2.0, price: 21680 }
        ],
        zone4: [ // Thailand
          { maxWeight: 0.1, price: 4650 },
          { maxWeight: 0.2, price: 5780 },
          { maxWeight: 0.3, price: 6920 },
          { maxWeight: 0.4, price: 8050 },
          { maxWeight: 0.5, price: 9190 },
          { maxWeight: 0.6, price: 10270 },
          { maxWeight: 0.7, price: 11340 },
          { maxWeight: 0.8, price: 12420 },
          { maxWeight: 0.9, price: 13490 },
          { maxWeight: 1.0, price: 14570 },
          { maxWeight: 1.5, price: 19280 },
          { maxWeight: 2.0, price: 23100 }
        ],
        zone5: [ // Philippines
          { maxWeight: 0.1, price: 4650 },
          { maxWeight: 0.2, price: 5890 },
          { maxWeight: 0.3, price: 7130 },
          { maxWeight: 0.4, price: 8370 },
          { maxWeight: 0.5, price: 9610 },
          { maxWeight: 0.6, price: 10790 },
          { maxWeight: 0.7, price: 11980 },
          { maxWeight: 0.8, price: 13160 },
          { maxWeight: 0.9, price: 14350 },
          { maxWeight: 1.0, price: 15530 },
          { maxWeight: 1.5, price: 22130 },
          { maxWeight: 2.0, price: 27380 }
        ],
        zone6: [ // Singapore
          { maxWeight: 0.1, price: 4760 },
          { maxWeight: 0.2, price: 5930 },
          { maxWeight: 0.3, price: 7110 },
          { maxWeight: 0.4, price: 8290 },
          { maxWeight: 0.5, price: 9460 },
          { maxWeight: 0.6, price: 10580 },
          { maxWeight: 0.7, price: 11690 },
          { maxWeight: 0.8, price: 12810 },
          { maxWeight: 0.9, price: 13930 },
          { maxWeight: 1.0, price: 15040 },
          { maxWeight: 1.5, price: 19250 },
          { maxWeight: 2.0, price: 24000 }
        ],
        zone7: [ // Indonesia
          { maxWeight: 0.1, price: 4870 },
          { maxWeight: 0.2, price: 6180 },
          { maxWeight: 0.3, price: 7480 },
          { maxWeight: 0.4, price: 8790 },
          { maxWeight: 0.5, price: 10100 },
          { maxWeight: 0.6, price: 11350 },
          { maxWeight: 0.7, price: 12600 },
          { maxWeight: 0.8, price: 13850 },
          { maxWeight: 0.9, price: 15100 },
          { maxWeight: 1.0, price: 16350 },
          { maxWeight: 1.5, price: 21780 },
          { maxWeight: 2.0, price: 26300 }
        ],
        zone8: [ // Malaysia
          { maxWeight: 0.1, price: 4950 },
          { maxWeight: 0.2, price: 6180 },
          { maxWeight: 0.3, price: 7420 },
          { maxWeight: 0.4, price: 8660 },
          { maxWeight: 0.5, price: 9890 },
          { maxWeight: 0.6, price: 11070 },
          { maxWeight: 0.7, price: 12240 },
          { maxWeight: 0.8, price: 13420 },
          { maxWeight: 0.9, price: 14590 },
          { maxWeight: 1.0, price: 15770 },
          { maxWeight: 1.5, price: 20520 },
          { maxWeight: 2.0, price: 25270 }
        ],
        zone9: [ // Vietnam
          { maxWeight: 0.1, price: 5110 },
          { maxWeight: 0.2, price: 5900 },
          { maxWeight: 0.3, price: 6680 },
          { maxWeight: 0.4, price: 7460 },
          { maxWeight: 0.5, price: 8240 },
          { maxWeight: 0.6, price: 9030 },
          { maxWeight: 0.7, price: 9810 },
          { maxWeight: 0.8, price: 10590 },
          { maxWeight: 0.9, price: 11370 },
          { maxWeight: 1.0, price: 12150 },
          { maxWeight: 1.5, price: 15540 },
          { maxWeight: 2.0, price: 18140 }
        ]
      }
    },

    // EMS Express rates (1-2 weeks delivery)
    ems: {
      zones: {
        'Singapore': { zone: 'zone1', korean: '싱가포르' },
        'Vietnam': { zone: 'zone1', korean: '베트남' },
        'Malaysia': { zone: 'zone2', korean: '말레이시아' },
        'Taiwan': { zone: 'zone2', korean: '대만' },
        'Thailand': { zone: 'zone3', korean: '태국' },
        'Philippines': { zone: 'zone3', korean: '필리핀' },
        'Indonesia': { zone: 'zone3', korean: '인도네시아' },
        'India': { zone: 'zone4', korean: '인도' },
        'Hong Kong': { zone: 'zone5', korean: '홍콩' },
        'Japan': { zone: 'zone6', korean: '일본' },
        'China': { zone: 'zone7', korean: '중국' },
        'Australia': { zone: 'zone8', korean: '호주' },
        'New Zealand': { zone: 'zone9', korean: '뉴질랜드' },
        'United States': { zone: 'zone10', korean: '미국' },
        'Canada': { zone: 'zone11', korean: '캐나다' },
        'Mexico': { zone: 'zone12', korean: '멕시코' },
        'Europe': { zone: 'zone13', korean: '유럽' },
        'Middle East': { zone: 'zone14', korean: '중동' },
        'Russia': { zone: 'zone15', korean: '러시아' },
        'Oceania': { zone: 'zone16', korean: '오세아니아' },
        'Brazil': { zone: 'zone17', korean: '브라질' },
        'South America': { zone: 'zone18', korean: '남미' }
      },
      rates: {
        zone1: [ // Singapore, Vietnam
          { maxWeight: 0.5, price: 15062 },
          { maxWeight: 1.0, price: 18125 },
          { maxWeight: 1.5, price: 21187 },
          { maxWeight: 2.0, price: 24250 },
          { maxWeight: 2.5, price: 26312 },
          { maxWeight: 3.0, price: 28875 },
          { maxWeight: 4.0, price: 33500 },
          { maxWeight: 5.0, price: 38125 },
          { maxWeight: 6.0, price: 43250 },
          { maxWeight: 7.0, price: 47875 },
          { maxWeight: 10.0, price: 62500 },
          { maxWeight: 15.0, price: 87500 },
          { maxWeight: 20.0, price: 112500 },
          { maxWeight: 25.0, price: 137500 },
          { maxWeight: 30.0, price: 162500 }
        ],
        zone2: [ // Malaysia, Taiwan
          { maxWeight: 0.5, price: 17775 },
          { maxWeight: 1.0, price: 19550 },
          { maxWeight: 1.5, price: 21825 },
          { maxWeight: 2.0, price: 23600 },
          { maxWeight: 2.5, price: 25375 },
          { maxWeight: 3.0, price: 27150 },
          { maxWeight: 4.0, price: 30700 },
          { maxWeight: 5.0, price: 33750 },
          { maxWeight: 6.0, price: 37300 },
          { maxWeight: 7.0, price: 41350 },
          { maxWeight: 10.0, price: 54500 },
          { maxWeight: 15.0, price: 76250 },
          { maxWeight: 20.0, price: 98000 },
          { maxWeight: 25.0, price: 119750 },
          { maxWeight: 30.0, price: 141500 }
        ],
        zone3: [ // Thailand, Philippines, Indonesia
          { maxWeight: 0.5, price: 18537 },
          { maxWeight: 1.0, price: 21075 },
          { maxWeight: 1.5, price: 23112 },
          { maxWeight: 2.0, price: 25150 },
          { maxWeight: 2.5, price: 27187 },
          { maxWeight: 3.0, price: 29225 },
          { maxWeight: 4.0, price: 33300 },
          { maxWeight: 5.0, price: 36875 },
          { maxWeight: 6.0, price: 40950 },
          { maxWeight: 7.0, price: 44525 },
          { maxWeight: 10.0, price: 58950 },
          { maxWeight: 15.0, price: 82425 },
          { maxWeight: 20.0, price: 105900 },
          { maxWeight: 25.0, price: 129375 },
          { maxWeight: 30.0, price: 152850 }
        ],
        zone4: [ // India
          { maxWeight: 0.5, price: 20500 },
          { maxWeight: 1.0, price: 22500 },
          { maxWeight: 1.5, price: 24500 },
          { maxWeight: 2.0, price: 26500 },
          { maxWeight: 2.5, price: 28500 },
          { maxWeight: 3.0, price: 30500 },
          { maxWeight: 4.0, price: 34000 },
          { maxWeight: 5.0, price: 37500 },
          { maxWeight: 6.0, price: 41000 },
          { maxWeight: 7.0, price: 44500 },
          { maxWeight: 10.0, price: 58000 },
          { maxWeight: 15.0, price: 81000 },
          { maxWeight: 20.0, price: 104000 },
          { maxWeight: 25.0, price: 127000 },
          { maxWeight: 30.0, price: 150000 }
        ],
        zone5: [ // Hong Kong
          { maxWeight: 0.5, price: 22525 },
          { maxWeight: 1.0, price: 24550 },
          { maxWeight: 1.5, price: 26575 },
          { maxWeight: 2.0, price: 28600 },
          { maxWeight: 2.5, price: 30125 },
          { maxWeight: 3.0, price: 31650 },
          { maxWeight: 4.0, price: 34700 },
          { maxWeight: 5.0, price: 37250 },
          { maxWeight: 6.0, price: 40300 },
          { maxWeight: 7.0, price: 43350 },
          { maxWeight: 10.0, price: 56400 },
          { maxWeight: 15.0, price: 78900 },
          { maxWeight: 20.0, price: 101400 },
          { maxWeight: 25.0, price: 123900 },
          { maxWeight: 30.0, price: 146400 }
        ],
        zone6: [ // Japan
          { maxWeight: 0.5, price: 17650 },
          { maxWeight: 1.0, price: 20800 },
          { maxWeight: 1.5, price: 23950 },
          { maxWeight: 2.0, price: 27100 },
          { maxWeight: 2.5, price: 29750 },
          { maxWeight: 3.0, price: 32400 },
          { maxWeight: 4.0, price: 37700 },
          { maxWeight: 5.0, price: 43000 },
          { maxWeight: 6.0, price: 48300 },
          { maxWeight: 7.0, price: 53600 },
          { maxWeight: 10.0, price: 70750 },
          { maxWeight: 15.0, price: 99000 },
          { maxWeight: 20.0, price: 127250 },
          { maxWeight: 25.0, price: 155500 },
          { maxWeight: 30.0, price: 183750 }
        ],
        zone7: [ // China
          { maxWeight: 0.5, price: 23550 },
          { maxWeight: 1.0, price: 26600 },
          { maxWeight: 1.5, price: 30150 },
          { maxWeight: 2.0, price: 32700 },
          { maxWeight: 2.5, price: 34250 },
          { maxWeight: 3.0, price: 35800 },
          { maxWeight: 4.0, price: 39400 },
          { maxWeight: 5.0, price: 42500 },
          { maxWeight: 6.0, price: 46100 },
          { maxWeight: 7.0, price: 49200 },
          { maxWeight: 10.0, price: 64000 },
          { maxWeight: 15.0, price: 89500 },
          { maxWeight: 20.0, price: 115000 },
          { maxWeight: 25.0, price: 140500 },
          { maxWeight: 30.0, price: 166000 }
        ],
        zone8: [ // Australia
          { maxWeight: 0.5, price: 23950 },
          { maxWeight: 1.0, price: 28850 },
          { maxWeight: 1.5, price: 33775 },
          { maxWeight: 2.0, price: 39200 },
          { maxWeight: 2.5, price: 43625 },
          { maxWeight: 3.0, price: 48050 },
          { maxWeight: 4.0, price: 57400 },
          { maxWeight: 5.0, price: 66750 },
          { maxWeight: 6.0, price: 76100 },
          { maxWeight: 7.0, price: 85950 },
          { maxWeight: 10.0, price: 113500 },
          { maxWeight: 15.0, price: 158900 },
          { maxWeight: 20.0, price: 204300 },
          { maxWeight: 25.0, price: 249700 },
          { maxWeight: 30.0, price: 295100 }
        ],
        zone9: [ // New Zealand
          { maxWeight: 0.5, price: 26387 },
          { maxWeight: 1.0, price: 30775 },
          { maxWeight: 1.5, price: 34162 },
          { maxWeight: 2.0, price: 38050 },
          { maxWeight: 2.5, price: 41937 },
          { maxWeight: 3.0, price: 45325 },
          { maxWeight: 4.0, price: 53100 },
          { maxWeight: 5.0, price: 60375 },
          { maxWeight: 6.0, price: 67650 },
          { maxWeight: 7.0, price: 75925 },
          { maxWeight: 10.0, price: 100250 },
          { maxWeight: 15.0, price: 140350 },
          { maxWeight: 20.0, price: 180450 },
          { maxWeight: 25.0, price: 220550 },
          { maxWeight: 30.0, price: 260650 }
        ],
        zone10: [ // United States
          { maxWeight: 0.5, price: 27112 },
          { maxWeight: 1.0, price: 34725 },
          { maxWeight: 1.5, price: 42337 },
          { maxWeight: 2.0, price: 49950 },
          { maxWeight: 2.5, price: 57562 },
          { maxWeight: 3.0, price: 64675 },
          { maxWeight: 4.0, price: 79400 },
          { maxWeight: 5.0, price: 94125 },
          { maxWeight: 6.0, price: 109350 },
          { maxWeight: 7.0, price: 124075 },
          { maxWeight: 10.0, price: 163800 },
          { maxWeight: 15.0, price: 229300 },
          { maxWeight: 20.0, price: 294800 },
          { maxWeight: 25.0, price: 360300 },
          { maxWeight: 30.0, price: 425800 }
        ],
        zone11: [ // Canada
          { maxWeight: 0.5, price: 29725 },
          { maxWeight: 1.0, price: 34450 },
          { maxWeight: 1.5, price: 39175 },
          { maxWeight: 2.0, price: 44400 },
          { maxWeight: 2.5, price: 49125 },
          { maxWeight: 3.0, price: 53350 },
          { maxWeight: 4.0, price: 62800 },
          { maxWeight: 5.0, price: 71750 },
          { maxWeight: 6.0, price: 80700 },
          { maxWeight: 7.0, price: 90650 },
          { maxWeight: 10.0, price: 119700 },
          { maxWeight: 15.0, price: 167600 },
          { maxWeight: 20.0, price: 215500 },
          { maxWeight: 25.0, price: 263400 },
          { maxWeight: 30.0, price: 311300 }
        ],
        zone12: [ // Mexico
          { maxWeight: 0.5, price: 29025 },
          { maxWeight: 1.0, price: 33550 },
          { maxWeight: 1.5, price: 38575 },
          { maxWeight: 2.0, price: 43600 },
          { maxWeight: 2.5, price: 48125 },
          { maxWeight: 3.0, price: 52650 },
          { maxWeight: 4.0, price: 61700 },
          { maxWeight: 5.0, price: 71750 },
          { maxWeight: 6.0, price: 81800 },
          { maxWeight: 7.0, price: 91850 },
          { maxWeight: 10.0, price: 121300 },
          { maxWeight: 15.0, price: 169850 },
          { maxWeight: 20.0, price: 218400 },
          { maxWeight: 25.0, price: 266950 },
          { maxWeight: 30.0, price: 315500 }
        ],
        zone13: [ // Europe
          { maxWeight: 0.5, price: 32825 },
          { maxWeight: 1.0, price: 39650 },
          { maxWeight: 1.5, price: 46975 },
          { maxWeight: 2.0, price: 53800 },
          { maxWeight: 2.5, price: 60625 },
          { maxWeight: 3.0, price: 66950 },
          { maxWeight: 4.0, price: 80600 },
          { maxWeight: 5.0, price: 95750 },
          { maxWeight: 6.0, price: 113400 },
          { maxWeight: 7.0, price: 131050 },
          { maxWeight: 10.0, price: 173050 },
          { maxWeight: 15.0, price: 242300 },
          { maxWeight: 20.0, price: 311550 },
          { maxWeight: 25.0, price: 380800 },
          { maxWeight: 30.0, price: 450050 }
        ],
        zone14: [ // Middle East
          { maxWeight: 0.5, price: 32723 },
          { maxWeight: 1.0, price: 38946 },
          { maxWeight: 1.5, price: 45169 },
          { maxWeight: 2.0, price: 51392 },
          { maxWeight: 2.5, price: 57615 },
          { maxWeight: 3.0, price: 63338 },
          { maxWeight: 4.0, price: 75784 },
          { maxWeight: 5.0, price: 87730 },
          { maxWeight: 6.0, price: 99676 },
          { maxWeight: 7.0, price: 114123 },
          { maxWeight: 10.0, price: 150700 },
          { maxWeight: 15.0, price: 210950 },
          { maxWeight: 20.0, price: 271200 },
          { maxWeight: 25.0, price: 331450 },
          { maxWeight: 30.0, price: 391700 }
        ],
        zone15: [ // Russia
          { maxWeight: 0.5, price: 33212 },
          { maxWeight: 1.0, price: 39925 },
          { maxWeight: 1.5, price: 46637 },
          { maxWeight: 2.0, price: 53850 },
          { maxWeight: 2.5, price: 59562 },
          { maxWeight: 3.0, price: 64775 },
          { maxWeight: 4.0, price: 76200 },
          { maxWeight: 5.0, price: 87625 },
          { maxWeight: 6.0, price: 98550 },
          { maxWeight: 7.0, price: 109975 },
          { maxWeight: 10.0, price: 145250 },
          { maxWeight: 15.0, price: 203350 },
          { maxWeight: 20.0, price: 261450 },
          { maxWeight: 25.0, price: 319550 },
          { maxWeight: 30.0, price: 377650 }
        ],
        zone16: [ // Oceania
          { maxWeight: 0.5, price: 33675 },
          { maxWeight: 1.0, price: 38350 },
          { maxWeight: 1.5, price: 43025 },
          { maxWeight: 2.0, price: 47200 },
          { maxWeight: 2.5, price: 51375 },
          { maxWeight: 3.0, price: 55550 },
          { maxWeight: 4.0, price: 63900 },
          { maxWeight: 5.0, price: 72250 },
          { maxWeight: 6.0, price: 80100 },
          { maxWeight: 7.0, price: 89950 },
          { maxWeight: 10.0, price: 118750 },
          { maxWeight: 15.0, price: 166250 },
          { maxWeight: 20.0, price: 213750 },
          { maxWeight: 25.0, price: 261250 },
          { maxWeight: 30.0, price: 308750 }
        ],
        zone17: [ // Brazil
          { maxWeight: 0.5, price: 35950 },
          { maxWeight: 1.0, price: 44900 },
          { maxWeight: 1.5, price: 53850 },
          { maxWeight: 2.0, price: 62800 },
          { maxWeight: 2.5, price: 71250 },
          { maxWeight: 3.0, price: 79700 },
          { maxWeight: 4.0, price: 100600 },
          { maxWeight: 5.0, price: 122000 },
          { maxWeight: 6.0, price: 142900 },
          { maxWeight: 7.0, price: 164300 },
          { maxWeight: 10.0, price: 216850 },
          { maxWeight: 15.0, price: 303600 },
          { maxWeight: 20.0, price: 390350 },
          { maxWeight: 25.0, price: 477100 },
          { maxWeight: 30.0, price: 563850 }
        ],
        zone18: [ // South America
          { maxWeight: 0.5, price: 30862 },
          { maxWeight: 1.0, price: 35725 },
          { maxWeight: 1.5, price: 40087 },
          { maxWeight: 2.0, price: 44950 },
          { maxWeight: 2.5, price: 48812 },
          { maxWeight: 3.0, price: 52675 },
          { maxWeight: 4.0, price: 60900 },
          { maxWeight: 5.0, price: 68625 },
          { maxWeight: 6.0, price: 76850 },
          { maxWeight: 7.0, price: 85075 },
          { maxWeight: 10.0, price: 112350 },
          { maxWeight: 15.0, price: 157300 },
          { maxWeight: 20.0, price: 202250 },
          { maxWeight: 25.0, price: 247200 },
          { maxWeight: 30.0, price: 292150 }
        ]
      }
    },

    // FedEx Priority rates (5-10 days delivery)
    fedex: {
      zones: {
        'Japan': { zone: 'P', korean: '일본' },
        'China': { zone: 'W', korean: '중국' },
        'United States': { zone: 'E', korean: '미국' },
        'Canada': { zone: 'M', korean: '캐나다' },
        'Mexico': { zone: 'M', korean: '멕시코' },
        'Oceania': { zone: 'U', korean: '오세아니아' },
        'Singapore': { zone: 'Y', korean: '싱가포르' },
        'Hong Kong': { zone: 'V', korean: '홍콩' },
        'Southeast Asia': { zone: 'N', korean: '동남아시아' },
        'Thailand': { zone: 'R', korean: '태국' },
        'Malaysia': { zone: 'Q', korean: '말레이시아' },
        'Taiwan': { zone: 'X', korean: '대만' },
        'Philippines': { zone: 'S', korean: '필리핀' },
        'India': { zone: 'O', korean: '인도' },
        'Indonesia': { zone: 'T', korean: '인도네시아' },
        'Macau': { zone: 'A', korean: '마카오' },
        'South America': { zone: 'J', korean: '남미' },
        'Brazil': { zone: 'I', korean: '브라질' },
        'Central Asia': { zone: 'D', korean: '중앙아시아' }
      },
      rates: {
        'P': [ // Japan
          { maxWeight: 0.5, price: 22720 },
          { maxWeight: 1.0, price: 24104 },
          { maxWeight: 1.5, price: 25374 },
          { maxWeight: 2.0, price: 27089 },
          { maxWeight: 2.5, price: 28752 },
          { maxWeight: 3.0, price: 30441 },
          { maxWeight: 4.0, price: 33807 },
          { maxWeight: 5.0, price: 37172 },
          { maxWeight: 6.0, price: 45186 },
          { maxWeight: 7.0, price: 48247 },
          { maxWeight: 10.0, price: 57429 },
          { maxWeight: 15.0, price: 113626 },
          { maxWeight: 20.0, price: 150609 },
          { maxWeight: 25.0, price: 183870 },
          { maxWeight: 30.0, price: 222643 }
        ],
        'W': [ // China/Hong Kong
          { maxWeight: 0.5, price: 25184 },
          { maxWeight: 1.0, price: 26530 },
          { maxWeight: 1.5, price: 27660 },
          { maxWeight: 2.0, price: 29514 },
          { maxWeight: 2.5, price: 31381 },
          { maxWeight: 3.0, price: 33286 },
          { maxWeight: 4.0, price: 37084 },
          { maxWeight: 5.0, price: 40868 },
          { maxWeight: 6.0, price: 42430 },
          { maxWeight: 7.0, price: 50038 },
          { maxWeight: 10.0, price: 59575 },
          { maxWeight: 15.0, price: 123888 },
          { maxWeight: 20.0, price: 155917 },
          { maxWeight: 25.0, price: 205282 },
          { maxWeight: 30.0, price: 248272 }
        ],
        'E': [ // United States
          { maxWeight: 0.5, price: 23799 },
          { maxWeight: 1.0, price: 26555 },
          { maxWeight: 1.5, price: 29044 },
          { maxWeight: 2.0, price: 31483 },
          { maxWeight: 2.5, price: 33807 },
          { maxWeight: 3.0, price: 36182 },
          { maxWeight: 4.0, price: 41948 },
          { maxWeight: 5.0, price: 47713 },
          { maxWeight: 6.0, price: 63550 },
          { maxWeight: 7.0, price: 70002 },
          { maxWeight: 10.0, price: 90462 },
          { maxWeight: 15.0, price: 126542 },
          { maxWeight: 20.0, price: 150101 },
          { maxWeight: 25.0, price: 197954 },
          { maxWeight: 30.0, price: 240322 }
        ],
        'M': [ // Canada, Mexico
          { maxWeight: 0.5, price: 26141 },
          { maxWeight: 1.0, price: 30892 },
          { maxWeight: 1.5, price: 35732 },
          { maxWeight: 2.0, price: 40344 },
          { maxWeight: 2.5, price: 44854 },
          { maxWeight: 3.0, price: 47548 },
          { maxWeight: 4.0, price: 55729 },
          { maxWeight: 5.0, price: 63924 },
          { maxWeight: 6.0, price: 78278 },
          { maxWeight: 7.0, price: 86701 },
          { maxWeight: 10.0, price: 118765 },
          { maxWeight: 15.0, price: 164119 },
          { maxWeight: 20.0, price: 205282 },
          { maxWeight: 25.0, price: 274004 },
          { maxWeight: 30.0, price: 331778 }
        ],
        'U': [ // Oceania
          { maxWeight: 0.5, price: 27546 },
          { maxWeight: 1.0, price: 31115 },
          { maxWeight: 1.5, price: 31115 },
          { maxWeight: 2.0, price: 33642 },
          { maxWeight: 2.5, price: 36029 },
          { maxWeight: 3.0, price: 39268 },
          { maxWeight: 4.0, price: 45732 },
          { maxWeight: 5.0, price: 52209 },
          { maxWeight: 6.0, price: 65570 },
          { maxWeight: 7.0, price: 72110 },
          { maxWeight: 10.0, price: 91744 },
          { maxWeight: 15.0, price: 188379 },
          { maxWeight: 20.0, price: 230060 },
          { maxWeight: 25.0, price: 311073 },
          { maxWeight: 30.0, price: 376466 }
        ],
        'Y': [ // Singapore
          { maxWeight: 0.5, price: 16967 },
          { maxWeight: 1.0, price: 18389 },
          { maxWeight: 1.5, price: 20942 },
          { maxWeight: 2.0, price: 22237 },
          { maxWeight: 2.5, price: 23533 },
          { maxWeight: 3.0, price: 24726 },
          { maxWeight: 4.0, price: 27127 },
          { maxWeight: 5.0, price: 29527 },
          { maxWeight: 6.0, price: 32994 },
          { maxWeight: 7.0, price: 35077 },
          { maxWeight: 10.0, price: 41338 },
          { maxWeight: 15.0, price: 84950 },
          { maxWeight: 20.0, price: 101295 },
          { maxWeight: 25.0, price: 125412 },
          { maxWeight: 30.0, price: 151714 }
        ],
        'V': [ // Hong Kong
          { maxWeight: 0.5, price: 19494 },
          { maxWeight: 1.0, price: 22352 },
          { maxWeight: 1.5, price: 23723 },
          { maxWeight: 2.0, price: 25184 },
          { maxWeight: 2.5, price: 26657 },
          { maxWeight: 3.0, price: 28016 },
          { maxWeight: 4.0, price: 30734 },
          { maxWeight: 5.0, price: 33451 },
          { maxWeight: 6.0, price: 36664 },
          { maxWeight: 7.0, price: 45935 },
          { maxWeight: 10.0, price: 45935 },
          { maxWeight: 15.0, price: 87096 },
          { maxWeight: 20.0, price: 103860 },
          { maxWeight: 25.0, price: 143510 },
          { maxWeight: 30.0, price: 173609 }
        ],
        'N': [ // Southeast Asia
          { maxWeight: 0.5, price: 19646 },
          { maxWeight: 1.0, price: 20967 },
          { maxWeight: 1.5, price: 21539 },
          { maxWeight: 2.0, price: 22987 },
          { maxWeight: 2.5, price: 24447 },
          { maxWeight: 3.0, price: 25920 },
          { maxWeight: 4.0, price: 28879 },
          { maxWeight: 5.0, price: 31838 },
          { maxWeight: 6.0, price: 39954 },
          { maxWeight: 7.0, price: 42659 },
          { maxWeight: 10.0, price: 50774 },
          { maxWeight: 15.0, price: 93205 },
          { maxWeight: 20.0, price: 117297 },
          { maxWeight: 25.0, price: 217309 },
          { maxWeight: 30.0, price: 262826 }
        ],
        'R': [ // Thailand
          { maxWeight: 0.5, price: 20205 },
          { maxWeight: 1.0, price: 22796 },
          { maxWeight: 1.5, price: 23660 },
          { maxWeight: 2.0, price: 25247 },
          { maxWeight: 2.5, price: 26847 },
          { maxWeight: 3.0, price: 28473 },
          { maxWeight: 4.0, price: 31724 },
          { maxWeight: 5.0, price: 34975 },
          { maxWeight: 6.0, price: 46863 },
          { maxWeight: 7.0, price: 50038 },
          { maxWeight: 10.0, price: 59575 },
          { maxWeight: 15.0, price: 123888 },
          { maxWeight: 20.0, price: 155917 },
          { maxWeight: 25.0, price: 205282 },
          { maxWeight: 30.0, price: 248272 }
        ],
        'Q': [ // Malaysia
          { maxWeight: 0.5, price: 20459 },
          { maxWeight: 1.0, price: 23368 },
          { maxWeight: 1.5, price: 25704 },
          { maxWeight: 2.0, price: 27432 },
          { maxWeight: 2.5, price: 29171 },
          { maxWeight: 3.0, price: 30937 },
          { maxWeight: 4.0, price: 34467 },
          { maxWeight: 5.0, price: 37985 },
          { maxWeight: 6.0, price: 44653 },
          { maxWeight: 7.0, price: 47675 },
          { maxWeight: 10.0, price: 56756 },
          { maxWeight: 15.0, price: 100050 },
          { maxWeight: 20.0, price: 125920 },
          { maxWeight: 25.0, price: 156235 },
          { maxWeight: 30.0, price: 188963 }
        ],
        'X': [ // Taiwan
          { maxWeight: 0.5, price: 21780 },
          { maxWeight: 1.0, price: 22987 },
          { maxWeight: 1.5, price: 24053 },
          { maxWeight: 2.0, price: 25539 },
          { maxWeight: 2.5, price: 27025 },
          { maxWeight: 3.0, price: 28397 },
          { maxWeight: 4.0, price: 31153 },
          { maxWeight: 5.0, price: 33909 },
          { maxWeight: 6.0, price: 40386 },
          { maxWeight: 7.0, price: 42938 },
          { maxWeight: 10.0, price: 50609 },
          { maxWeight: 15.0, price: 100088 },
          { maxWeight: 20.0, price: 119354 },
          { maxWeight: 25.0, price: 193522 },
          { maxWeight: 30.0, price: 234111 }
        ],
        'S': [ // Philippines
          { maxWeight: 0.5, price: 21869 },
          { maxWeight: 1.0, price: 23926 },
          { maxWeight: 1.5, price: 25552 },
          { maxWeight: 2.0, price: 27266 },
          { maxWeight: 2.5, price: 28994 },
          { maxWeight: 3.0, price: 30746 },
          { maxWeight: 4.0, price: 34251 },
          { maxWeight: 5.0, price: 37757 },
          { maxWeight: 6.0, price: 41795 },
          { maxWeight: 7.0, price: 44627 },
          { maxWeight: 10.0, price: 53136 },
          { maxWeight: 15.0, price: 94284 },
          { maxWeight: 20.0, price: 118668 },
          { maxWeight: 25.0, price: 192519 },
          { maxWeight: 30.0, price: 232841 }
        ],
        'O': [ // India
          { maxWeight: 0.5, price: 22720 },
          { maxWeight: 1.0, price: 29895 },
          { maxWeight: 1.5, price: 35064 },
          { maxWeight: 2.0, price: 38493 },
          { maxWeight: 2.5, price: 41833 },
          { maxWeight: 3.0, price: 53543 },
          { maxWeight: 4.0, price: 61353 },
          { maxWeight: 5.0, price: 69164 },
          { maxWeight: 6.0, price: 73152 },
          { maxWeight: 7.0, price: 79375 },
          { maxWeight: 10.0, price: 97764 },
          { maxWeight: 15.0, price: 121881 },
          { maxWeight: 20.0, price: 157264 },
          { maxWeight: 25.0, price: 192405 },
          { maxWeight: 30.0, price: 233070 }
        ],
        'T': [ // Indonesia
          { maxWeight: 0.5, price: 32626 },
          { maxWeight: 1.0, price: 35255 },
          { maxWeight: 1.5, price: 39065 },
          { maxWeight: 2.0, price: 41681 },
          { maxWeight: 2.5, price: 44323 },
          { maxWeight: 3.0, price: 47002 },
          { maxWeight: 4.0, price: 52362 },
          { maxWeight: 5.0, price: 57721 },
          { maxWeight: 6.0, price: 60185 },
          { maxWeight: 7.0, price: 64274 },
          { maxWeight: 10.0, price: 76504 },
          { maxWeight: 15.0, price: 122097 },
          { maxWeight: 20.0, price: 153670 },
          { maxWeight: 25.0, price: 264236 },
          { maxWeight: 30.0, price: 319570 }
        ],
        'A': [ // Macau
          { maxWeight: 0.5, price: 31826 },
          { maxWeight: 1.0, price: 34010 },
          { maxWeight: 1.5, price: 37325 },
          { maxWeight: 2.0, price: 39624 },
          { maxWeight: 2.5, price: 41922 },
          { maxWeight: 3.0, price: 44056 },
          { maxWeight: 4.0, price: 48336 },
          { maxWeight: 5.0, price: 52603 },
          { maxWeight: 6.0, price: 56273 },
          { maxWeight: 7.0, price: 59829 },
          { maxWeight: 10.0, price: 70497 },
          { maxWeight: 15.0, price: 106680 },
          { maxWeight: 20.0, price: 127215 },
          { maxWeight: 25.0, price: 162864 },
          { maxWeight: 30.0, price: 197015 }
        ],
        'J': [ // South America
          { maxWeight: 0.5, price: 29108 },
          { maxWeight: 1.0, price: 36271 },
          { maxWeight: 1.5, price: 44018 },
          { maxWeight: 2.0, price: 48844 },
          { maxWeight: 2.5, price: 53467 },
          { maxWeight: 3.0, price: 55245 },
          { maxWeight: 4.0, price: 66433 },
          { maxWeight: 5.0, price: 77622 },
          { maxWeight: 6.0, price: 94030 },
          { maxWeight: 7.0, price: 105041 },
          { maxWeight: 10.0, price: 150342 },
          { maxWeight: 15.0, price: 213575 },
          { maxWeight: 20.0, price: 262724 },
          { maxWeight: 25.0, price: 323900 },
          { maxWeight: 30.0, price: 393700 }
        ],
        'I': [ // Brazil
          { maxWeight: 0.5, price: 43637 },
          { maxWeight: 1.0, price: 52108 },
          { maxWeight: 1.5, price: 63715 },
          { maxWeight: 2.0, price: 70942 },
          { maxWeight: 2.5, price: 77863 },
          { maxWeight: 3.0, price: 89306 },
          { maxWeight: 4.0, price: 107429 },
          { maxWeight: 5.0, price: 125539 },
          { maxWeight: 6.0, price: 152387 },
          { maxWeight: 7.0, price: 170319 },
          { maxWeight: 10.0, price: 243636 },
          { maxWeight: 15.0, price: 392633 },
          { maxWeight: 20.0, price: 480441 },
          { maxWeight: 25.0, price: 592302 },
          { maxWeight: 30.0, price: 719937 }
        ],
        'D': [ // Central Asia
          { maxWeight: 0.5, price: 45313 },
          { maxWeight: 1.0, price: 55003 },
          { maxWeight: 1.5, price: 59817 },
          { maxWeight: 2.0, price: 65659 },
          { maxWeight: 2.5, price: 71361 },
          { maxWeight: 3.0, price: 76974 },
          { maxWeight: 4.0, price: 88201 },
          { maxWeight: 5.0, price: 99428 },
          { maxWeight: 6.0, price: 103847 },
          { maxWeight: 7.0, price: 112687 },
          { maxWeight: 10.0, price: 139204 },
          { maxWeight: 15.0, price: 197599 },
          { maxWeight: 20.0, price: 236296 },
          { maxWeight: 25.0, price: 338658 },
          { maxWeight: 30.0, price: 410248 }
        ]
      }
    },

    // DHL Express rates (3-5 days delivery)
    dhl: {
      zones: {
        'Asia': { zone: 'zone1', korean: '아시아' },
        'Japan': { zone: 'zone2', korean: '일본' },
        'Southeast Asia': { zone: 'zone3', korean: '동남아시아' },
        'Oceania': { zone: 'zone4', korean: '오세아니아' },
        'China': { zone: 'zone5', korean: '중국' },
        'Europe': { zone: 'zone6', korean: '유럽' },
        'Middle East': { zone: 'zone7', korean: '중동' },
        'Brazil': { zone: 'zone8', korean: '브라질' }
      },
      rates: {
        zone1: [ // Asia
          { maxWeight: 0.5, price: 23650 },
          { maxWeight: 1.0, price: 27262 },
          { maxWeight: 1.5, price: 29293 },
          { maxWeight: 2.0, price: 31325 },
          { maxWeight: 2.5, price: 33296 },
          { maxWeight: 3.0, price: 37305 },
          { maxWeight: 4.0, price: 40835 },
          { maxWeight: 5.0, price: 44364 },
          { maxWeight: 6.0, price: 50560 },
          { maxWeight: 7.0, price: 54044 },
          { maxWeight: 10.0, price: 64495 },
          { maxWeight: 15.0, price: 125886 },
          { maxWeight: 20.0, price: 171607 },
          { maxWeight: 25.0, price: 208763 },
          { maxWeight: 30.0, price: 245919 }
        ],
        zone2: [ // Japan
          { maxWeight: 0.5, price: 24964 },
          { maxWeight: 1.0, price: 29013 },
          { maxWeight: 1.5, price: 31707 },
          { maxWeight: 2.0, price: 34401 },
          { maxWeight: 2.5, price: 37073 },
          { maxWeight: 3.0, price: 42095 },
          { maxWeight: 4.0, price: 47341 },
          { maxWeight: 5.0, price: 52586 },
          { maxWeight: 6.0, price: 60034 },
          { maxWeight: 7.0, price: 64441 },
          { maxWeight: 10.0, price: 77663 },
          { maxWeight: 15.0, price: 146040 },
          { maxWeight: 20.0, price: 196922 },
          { maxWeight: 25.0, price: 240244 },
          { maxWeight: 30.0, price: 283566 }
        ],
        zone3: [ // Southeast Asia
          { maxWeight: 0.5, price: 25084 },
          { maxWeight: 1.0, price: 29132 },
          { maxWeight: 1.5, price: 32525 },
          { maxWeight: 2.0, price: 35917 },
          { maxWeight: 2.5, price: 39249 },
          { maxWeight: 3.0, price: 44959 },
          { maxWeight: 4.0, price: 51274 },
          { maxWeight: 5.0, price: 57586 },
          { maxWeight: 6.0, price: 67099 },
          { maxWeight: 7.0, price: 73239 },
          { maxWeight: 10.0, price: 91657 },
          { maxWeight: 15.0, price: 175389 },
          { maxWeight: 20.0, price: 238548 },
          { maxWeight: 25.0, price: 290836 },
          { maxWeight: 30.0, price: 343124 }
        ],
        zone4: [ // Oceania
          { maxWeight: 0.5, price: 27851 },
          { maxWeight: 1.0, price: 32353 },
          { maxWeight: 1.5, price: 36171 },
          { maxWeight: 2.0, price: 39989 },
          { maxWeight: 2.5, price: 43638 },
          { maxWeight: 3.0, price: 47136 },
          { maxWeight: 4.0, price: 54131 },
          { maxWeight: 5.0, price: 61128 },
          { maxWeight: 6.0, price: 71425 },
          { maxWeight: 7.0, price: 78110 },
          { maxWeight: 10.0, price: 98167 },
          { maxWeight: 15.0, price: 190340 },
          { maxWeight: 20.0, price: 264367 },
          { maxWeight: 25.0, price: 322268 },
          { maxWeight: 30.0, price: 380107 }
        ],
        zone5: [ // China
          { maxWeight: 0.5, price: 31637 },
          { maxWeight: 1.0, price: 36721 },
          { maxWeight: 1.5, price: 39651 },
          { maxWeight: 2.0, price: 42581 },
          { maxWeight: 2.5, price: 49313 },
          { maxWeight: 3.0, price: 54911 },
          { maxWeight: 4.0, price: 68274 },
          { maxWeight: 5.0, price: 79499 },
          { maxWeight: 6.0, price: 89728 },
          { maxWeight: 7.0, price: 99685 },
          { maxWeight: 10.0, price: 129557 },
          { maxWeight: 15.0, price: 192354 },
          { maxWeight: 20.0, price: 219887 },
          { maxWeight: 25.0, price: 265774 },
          { maxWeight: 30.0, price: 326609 }
        ],
        zone6: [ // Europe
          { maxWeight: 0.5, price: 28173 },
          { maxWeight: 1.0, price: 34974 },
          { maxWeight: 1.5, price: 40300 },
          { maxWeight: 2.0, price: 45625 },
          { maxWeight: 2.5, price: 50851 },
          { maxWeight: 3.0, price: 59036 },
          { maxWeight: 4.0, price: 68637 },
          { maxWeight: 5.0, price: 78239 },
          { maxWeight: 6.0, price: 92364 },
          { maxWeight: 7.0, price: 101740 },
          { maxWeight: 10.0, price: 129867 },
          { maxWeight: 15.0, price: 263107 },
          { maxWeight: 20.0, price: 310886 },
          { maxWeight: 25.0, price: 390517 },
          { maxWeight: 30.0, price: 478264 }
        ],
        zone7: [ // Middle East
          { maxWeight: 0.5, price: 29550 },
          { maxWeight: 1.0, price: 37128 },
          { maxWeight: 1.5, price: 43491 },
          { maxWeight: 2.0, price: 49854 },
          { maxWeight: 2.5, price: 56117 },
          { maxWeight: 3.0, price: 65746 },
          { maxWeight: 4.0, price: 77487 },
          { maxWeight: 5.0, price: 89226 },
          { maxWeight: 6.0, price: 106179 },
          { maxWeight: 7.0, price: 117650 },
          { maxWeight: 10.0, price: 152064 },
          { maxWeight: 15.0, price: 311045 },
          { maxWeight: 20.0, price: 368303 },
          { maxWeight: 25.0, price: 463733 },
          { maxWeight: 30.0, price: 557474 }
        ],
        zone8: [ // Brazil
          { maxWeight: 0.5, price: 46094 },
          { maxWeight: 1.0, price: 51595 },
          { maxWeight: 1.5, price: 56596 },
          { maxWeight: 2.0, price: 61598 },
          { maxWeight: 2.5, price: 68757 },
          { maxWeight: 3.0, price: 80506 },
          { maxWeight: 4.0, price: 94682 },
          { maxWeight: 5.0, price: 108857 },
          { maxWeight: 6.0, price: 130175 },
          { maxWeight: 7.0, price: 144701 },
          { maxWeight: 10.0, price: 188282 },
          { maxWeight: 15.0, price: 389536 },
          { maxWeight: 20.0, price: 462689 },
          { maxWeight: 25.0, price: 584611 },
          { maxWeight: 30.0, price: 703981 }
        ]
      }
    }
  };

  // Carrier-destination mapping
  const carrierDestinations = {
    kpacket: ['Hong Kong', 'Taiwan', 'Japan', 'Thailand', 'Philippines', 'Singapore', 'Indonesia', 'Malaysia', 'Vietnam'],
    ems: ['Singapore', 'Vietnam', 'Malaysia', 'Taiwan', 'Thailand', 'Philippines', 'Indonesia', 'India',
          'Hong Kong', 'Japan', 'China', 'Australia', 'New Zealand', 'United States', 'Canada', 'Mexico',
          'Europe', 'Middle East', 'Russia', 'Oceania', 'Brazil', 'South America'],
    fedex: ['Japan', 'China', 'United States', 'Canada', 'Mexico', 'Oceania', 'Singapore', 'Hong Kong',
            'Southeast Asia', 'Thailand', 'Malaysia', 'Taiwan', 'Philippines', 'India', 'Indonesia',
            'Macau', 'South America', 'Brazil', 'Central Asia'],
    dhl: ['Asia', 'Japan', 'Southeast Asia', 'Oceania', 'China', 'Europe', 'Middle East', 'Brazil']
  };

  // Calculator state management
  let calculatorState = {
    currentStep: 1,
    selectedCarrier: null,
    selectedDestination: null,
    selectedWeight: null,
    selectedUnit: 'kg',
    calculatedPrice: null
  };

  // Initialize calculator when DOM is ready
  function initCalculator() {
    const calculatorForm = document.querySelector('.shipping-calculator-form');
    if (!calculatorForm) return;

    // Setup event listeners
    setupCarrierSelection();
    setupDestinationSelection();
    setupWeightInput();
    setupNavigationButtons();
    setupProgressBar();

    // Initialize first step
    showStep(1);
    updateProgressBar(1);
  }

  // Setup carrier dropdown
  function setupCarrierSelection() {
    const carrierSelect = document.getElementById('shipping-carrier');
    if (!carrierSelect) return;

    carrierSelect.addEventListener('change', function() {
      const selectedValue = this.value;
      calculatorState.selectedCarrier = selectedValue;

      if (selectedValue) {
        // Populate destination dropdown based on carrier
        populateDestinations(selectedValue);

        // Show destination dropdown container
        const destinationContainer = document.querySelector('.destination-dropdown-container');
        if (destinationContainer) {
          destinationContainer.style.display = 'block';
        }

        // Enable next button
        updateNavigationButtons();
      } else {
        // Hide destination dropdown if no carrier selected
        const destinationContainer = document.querySelector('.destination-dropdown-container');
        if (destinationContainer) {
          destinationContainer.style.display = 'none';
        }

        // Reset destination selection
        calculatorState.selectedDestination = null;
        const destinationSelect = document.getElementById('destination-select');
        if (destinationSelect) {
          destinationSelect.innerHTML = '<option value="">-- Select destination --</option>';
        }
      }
    });
  }

  // Populate destinations based on selected carrier
  function populateDestinations(carrier) {
    const destinationSelect = document.getElementById('destination-select');
    if (!destinationSelect) return;

    const destinations = carrierDestinations[carrier] || [];

    let html = '<option value="">-- Select destination --</option>';
    destinations.forEach(dest => {
      html += `<option value="${dest}">${dest}</option>`;
    });

    destinationSelect.innerHTML = html;
  }

  // Setup destination selection
  function setupDestinationSelection() {
    const destinationSelect = document.getElementById('destination-select');
    if (!destinationSelect) return;

    destinationSelect.addEventListener('change', function() {
      calculatorState.selectedDestination = this.value;
      updateNavigationButtons();
    });
  }

  // Setup weight input
  function setupWeightInput() {
    const weightInput = document.getElementById('product-weight');
    const unitSelect = document.getElementById('weight-unit');

    if (weightInput) {
      weightInput.addEventListener('input', function() {
        const value = parseFloat(this.value);
        if (!isNaN(value) && value > 0) {
          // Convert to kg for calculation
          let weightInKg = value;
          if (calculatorState.selectedUnit === 'g') {
            weightInKg = value / 1000;
          } else if (calculatorState.selectedUnit === 'lb') {
            weightInKg = value * 0.453592;
          }
          calculatorState.selectedWeight = weightInKg;
        } else {
          calculatorState.selectedWeight = null;
        }
        updateNavigationButtons();
      });
    }

    if (unitSelect) {
      unitSelect.addEventListener('change', function() {
        calculatorState.selectedUnit = this.value;

        // Recalculate weight in kg if weight is already entered
        const weightInput = document.getElementById('product-weight');
        if (weightInput && weightInput.value) {
          const value = parseFloat(weightInput.value);
          if (!isNaN(value) && value > 0) {
            let weightInKg = value;
            if (this.value === 'g') {
              weightInKg = value / 1000;
            } else if (this.value === 'lb') {
              weightInKg = value * 0.453592;
            }
            calculatorState.selectedWeight = weightInKg;
          }
        }
      });
    }
  }

  // Setup navigation buttons
  function setupNavigationButtons() {
    const backBtn = document.getElementById('calc-back');
    const nextBtn = document.getElementById('calc-next');
    const calculateBtn = document.getElementById('calc-calculate');
    const resetBtn = document.getElementById('calc-reset');

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        // Check if results are currently displayed
        const resultsContainer = document.getElementById('shipping-results');
        if (resultsContainer && resultsContainer.style.display === 'block') {
          // Hide results and show step 3 again
          resultsContainer.style.display = 'none';
          showStep(3);
          updateProgressBar(3);
        } else if (calculatorState.currentStep > 1) {
          // Normal back navigation
          const previousStep = calculatorState.currentStep - 1;
          showStep(previousStep);
          updateProgressBar(previousStep);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (canProceedToNextStep()) {
          const nextStep = calculatorState.currentStep + 1;
          showStep(nextStep);
          updateProgressBar(nextStep);
        }
      });
    }

    if (calculateBtn) {
      calculateBtn.addEventListener('click', () => {
        calculateShipping();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        resetCalculator();
      });
    }
  }

  // Setup progress bar
  function setupProgressBar() {
    const progressSteps = document.querySelectorAll('.progress-step');
    progressSteps.forEach(step => {
      step.addEventListener('click', function() {
        const stepNumber = parseInt(this.dataset.step);
        if (canNavigateToStep(stepNumber)) {
          showStep(stepNumber);
          updateProgressBar(stepNumber);
        }
      });
    });
  }

  // Update progress bar visual state
  function updateProgressBar(step) {
    const progressFill = document.querySelector('.progress-fill');
    const progressSteps = document.querySelectorAll('.progress-step');

    if (progressFill) {
      const percentage = (step / 3) * 100;
      progressFill.style.width = `${percentage}%`;
    }

    progressSteps.forEach(stepEl => {
      const stepNum = parseInt(stepEl.dataset.step);
      if (stepNum <= step) {
        stepEl.classList.add('active');
      } else {
        stepEl.classList.remove('active');
      }
    });

    calculatorState.currentStep = step;
  }

  // Check if can proceed to next step
  function canProceedToNextStep() {
    switch (calculatorState.currentStep) {
      case 1:
        return calculatorState.selectedCarrier && calculatorState.selectedDestination;
      case 2:
        return calculatorState.selectedWeight && calculatorState.selectedWeight > 0;
      case 3:
        return true;
      default:
        return false;
    }
  }

  // Check if can navigate to specific step
  function canNavigateToStep(step) {
    if (step === 1) return true;
    if (step === 2) return calculatorState.selectedCarrier && calculatorState.selectedDestination;
    if (step === 3) return canNavigateToStep(2) && calculatorState.selectedWeight;
    return false;
  }

  // Show specific step
  function showStep(step) {
    const allSteps = document.querySelectorAll('.calc-step');
    allSteps.forEach(s => s.style.display = 'none');

    const targetStep = document.querySelector(`.calc-step[data-step="${step}"]`);
    if (targetStep) {
      targetStep.style.display = 'block';
    }

    calculatorState.currentStep = step;
    updateNavigationButtons();

    // If moving to step 3, show available shipping methods
    if (step === 3) {
      displayShippingMethods();
    }
  }

  // Update navigation buttons visibility and state
  function updateNavigationButtons() {
    const backBtn = document.getElementById('calc-back');
    const nextBtn = document.getElementById('calc-next');
    const calculateBtn = document.getElementById('calc-calculate');
    const resetBtn = document.getElementById('calc-reset');
    const resultsContainer = document.getElementById('shipping-results');

    // Back button - show if step > 1 or if results are displayed
    if (backBtn) {
      const isResultsShown = resultsContainer && resultsContainer.style.display === 'block';
      backBtn.style.display = (calculatorState.currentStep > 1 || isResultsShown) ? 'inline-flex' : 'none';
    }

    // Next button
    if (nextBtn) {
      if (calculatorState.currentStep < 3) {
        nextBtn.style.display = 'inline-flex';
        nextBtn.disabled = !canProceedToNextStep();
      } else {
        nextBtn.style.display = 'none';
      }
    }

    // Calculate button
    if (calculateBtn) {
      if (calculatorState.currentStep === 3) {
        calculateBtn.style.display = 'inline-flex';
        calculateBtn.disabled = false;
      } else {
        calculateBtn.style.display = 'none';
      }
    }

    // Reset button
    if (resetBtn) {
      const resultsVisible = document.getElementById('shipping-results')?.style.display === 'block';
      resetBtn.style.display = resultsVisible ? 'inline-flex' : 'none';
    }
  }

  // Display available shipping methods in step 3
  function displayShippingMethods() {
    const methodsContainer = document.getElementById('available-methods');
    if (!methodsContainer) return;

    const carrier = calculatorState.selectedCarrier;
    const destination = calculatorState.selectedDestination;
    const weight = calculatorState.selectedWeight;

    // Check if weight exceeds carrier limits
    const weightLimits = {
      kpacket: 2,
      ems: 30,
      fedex: 30,
      dhl: 30
    };

    let html = '';

    if (weight > weightLimits[carrier]) {
      html = `
        <div class="alert alert-warning">
          <h4>Weight Exceeds Limit</h4>
          <p>The selected carrier has a maximum weight limit of ${weightLimits[carrier]}kg.</p>
          <p>Your package weighs ${weight.toFixed(3)}kg.</p>
          <p>Please go back and select a different carrier or reduce the weight.</p>
        </div>
      `;
    } else {
      // Get carrier info
      let carrierName, deliveryTime, features;

      switch(carrier) {
        case 'kpacket':
          carrierName = 'K-Packet';
          deliveryTime = '3-6 weeks';
          features = ['Economy shipping', 'Basic tracking', 'Up to 2kg'];
          break;
        case 'ems':
          carrierName = 'EMS Express';
          deliveryTime = '1-2 weeks';
          features = ['Express delivery', 'Full tracking', 'Insurance available', 'Up to 30kg'];
          break;
        case 'fedex':
          carrierName = 'FedEx Priority';
          deliveryTime = '5-10 days';
          features = ['Priority handling', 'Real-time tracking', 'Door-to-door delivery', 'Up to 30kg'];
          break;
        case 'dhl':
          carrierName = 'DHL Express';
          deliveryTime = '3-5 days';
          features = ['Fastest delivery', 'Premium tracking', 'Express clearance', 'Up to 30kg'];
          break;
      }

      html = `
        <div class="shipping-method-summary">
          <div class="method-header">
            <h3>${carrierName}</h3>
            <span class="delivery-badge">${deliveryTime}</span>
          </div>

          <div class="method-details">
            <div class="detail-item">
              <span class="detail-label">Destination:</span>
              <span class="detail-value">${destination}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Package Weight:</span>
              <span class="detail-value">${weight.toFixed(3)} kg</span>
            </div>
          </div>

          <div class="method-features">
            <h4>Service Features</h4>
            <ul>
              ${features.map(f => `<li>${f}</li>`).join('')}
            </ul>
          </div>

          <div class="ready-to-calculate">
            <p><strong>Ready to Calculate:</strong> Click the button below to get your exact shipping cost with detailed breakdown.</p>
          </div>
        </div>
      `;
    }

    methodsContainer.innerHTML = html;
  }

  // Calculate shipping cost
  function calculateShipping() {
    const carrier = calculatorState.selectedCarrier;
    const destination = calculatorState.selectedDestination;
    const weight = calculatorState.selectedWeight;

    if (!carrier || !destination || !weight) {
      alert('Please complete all steps before calculating.');
      return;
    }

    // Get the appropriate rate structure
    const carrierRates = shippingRates[carrier];
    if (!carrierRates) {
      alert('Invalid carrier selected.');
      return;
    }

    // Find the zone for the destination
    const zoneInfo = carrierRates.zones[destination];
    if (!zoneInfo) {
      alert('Destination not available for selected carrier.');
      return;
    }

    // Get the rates for the zone
    const rates = carrierRates.rates[zoneInfo.zone];
    if (!rates) {
      alert('Rates not available for this route.');
      return;
    }

    // Find the price for the weight
    let price = null;
    for (let i = 0; i < rates.length; i++) {
      if (weight <= rates[i].maxWeight) {
        price = rates[i].price;
        break;
      }
    }

    if (price === null) {
      alert('Weight exceeds maximum limit for this service.');
      return;
    }

    // Calculate handling fee
    const settings = window.shippingCalculatorSettings || { handlingFeePercentage: 15, showHandlingFeeSeparate: true };
    const handlingFeePercentage = settings.handlingFeePercentage || 15;
    const handlingFee = Math.round(price * (handlingFeePercentage / 100));
    const totalPrice = price + handlingFee;

    calculatorState.calculatedPrice = totalPrice;
    calculatorState.baseShippingPrice = price;
    calculatorState.handlingFee = handlingFee;
    calculatorState.handlingFeePercentage = handlingFeePercentage;
    displayResults(totalPrice);
  }

  // Display calculation results
  function displayResults(price) {
    const resultsContainer = document.getElementById('shipping-results');
    const resultsSummary = resultsContainer.querySelector('.results-summary');
    const breakdownTable = resultsContainer.querySelector('.breakdown-table');

    if (!resultsContainer || !resultsSummary) return;

    // Get settings and calculated values
    const settings = window.shippingCalculatorSettings || { handlingFeePercentage: 15, showHandlingFeeSeparate: true };
    const baseShippingPrice = calculatorState.baseShippingPrice || price;
    const handlingFee = calculatorState.handlingFee || 0;
    const handlingFeePercentage = calculatorState.handlingFeePercentage || settings.handlingFeePercentage || 15;

    // Get carrier name for display
    const carrierNames = {
      kpacket: 'K-Packet',
      ems: 'EMS Express',
      fedex: 'FedEx Priority',
      dhl: 'DHL Express'
    };

    // Calculate prices in different currencies
    const exchangeRates = {
      USD: 1350,  // 1 USD = 1350 KRW
      EUR: 1500,  // 1 EUR = 1500 KRW
      GBP: 1700,  // 1 GBP = 1700 KRW
      JPY: 9.5    // 1 JPY = 9.5 KRW
    };

    const priceUSD = (price / exchangeRates.USD).toFixed(2);
    const priceEUR = (price / exchangeRates.EUR).toFixed(2);
    const priceGBP = (price / exchangeRates.GBP).toFixed(2);
    const priceJPY = Math.round(price / exchangeRates.JPY);

    // Update results summary
    resultsSummary.innerHTML = `
      <div class="result-card primary-result">
        <h3>Total Shipping Cost</h3>
        <div class="price-display">
          <span class="currency-symbol">₩</span>
          <span class="price-amount">${price.toLocaleString()}</span>
          <span class="currency-code">KRW</span>
        </div>
      </div>

      <div class="currency-conversions">
        <h4>Other Currencies</h4>
        <div class="conversion-grid">
          <div class="conversion-item">
            <span class="conv-currency">USD</span>
            <span class="conv-amount">$${priceUSD}</span>
          </div>
          <div class="conversion-item">
            <span class="conv-currency">EUR</span>
            <span class="conv-amount">€${priceEUR}</span>
          </div>
          <div class="conversion-item">
            <span class="conv-currency">GBP</span>
            <span class="conv-amount">£${priceGBP}</span>
          </div>
          <div class="conversion-item">
            <span class="conv-currency">JPY</span>
            <span class="conv-amount">¥${priceJPY.toLocaleString()}</span>
          </div>
        </div>
      </div>

      <div class="shipment-summary">
        <h4>Shipment Details</h4>
        <table class="summary-table">
          <tr>
            <td>Carrier:</td>
            <td><strong>${carrierNames[calculatorState.selectedCarrier]}</strong></td>
          </tr>
          <tr>
            <td>Destination:</td>
            <td><strong>${calculatorState.selectedDestination}</strong></td>
          </tr>
          <tr>
            <td>Weight:</td>
            <td><strong>${calculatorState.selectedWeight.toFixed(3)} kg</strong></td>
          </tr>
          <tr>
            <td>Estimated Delivery:</td>
            <td><strong>${getDeliveryTime(calculatorState.selectedCarrier)}</strong></td>
          </tr>
        </table>
      </div>
    `;

    // Update breakdown table
    if (breakdownTable) {
      let breakdownHTML = `
        <table class="breakdown-details">
          <tr>
            <td>Base Shipping Rate</td>
            <td class="text-right">₩${baseShippingPrice.toLocaleString()}</td>
          </tr>
          <tr>
            <td>Fuel Surcharge</td>
            <td class="text-right">Included</td>
          </tr>`;

      if (settings.showHandlingFeeSeparate && handlingFee > 0) {
        breakdownHTML += `
          <tr>
            <td>Handling Fee (${handlingFeePercentage}%)</td>
            <td class="text-right">₩${handlingFee.toLocaleString()}</td>
          </tr>`;
      } else {
        breakdownHTML += `
          <tr>
            <td>Handling Fee</td>
            <td class="text-right">Included</td>
          </tr>`;
      }

      breakdownHTML += `
          <tr class="total-row">
            <td><strong>Total Cost</strong></td>
            <td class="text-right"><strong>₩${price.toLocaleString()}</strong></td>
          </tr>
        </table>
      `;

      breakdownTable.innerHTML = breakdownHTML;
    }

    // Show results container
    resultsContainer.style.display = 'block';

    // Hide step 3 content
    document.querySelector('.calc-step[data-step="3"]').style.display = 'none';

    // Update navigation buttons
    updateNavigationButtons();

    // Scroll to results
    resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Get delivery time for carrier
  function getDeliveryTime(carrier) {
    const deliveryTimes = {
      kpacket: '3-6 weeks',
      ems: '1-2 weeks',
      fedex: '5-10 days',
      dhl: '3-5 days'
    };
    return deliveryTimes[carrier] || 'N/A';
  }

  // Reset calculator
  function resetCalculator() {
    // Reset state
    calculatorState = {
      currentStep: 1,
      selectedCarrier: null,
      selectedDestination: null,
      selectedWeight: null,
      selectedUnit: 'kg',
      calculatedPrice: null
    };

    // Reset form elements
    const carrierSelect = document.getElementById('shipping-carrier');
    if (carrierSelect) carrierSelect.value = '';

    const destinationSelect = document.getElementById('destination-select');
    if (destinationSelect) {
      destinationSelect.innerHTML = '<option value="">-- Select destination --</option>';
    }

    const destinationContainer = document.querySelector('.destination-dropdown-container');
    if (destinationContainer) {
      destinationContainer.style.display = 'none';
    }

    const weightInput = document.getElementById('product-weight');
    if (weightInput) weightInput.value = '';

    const unitSelect = document.getElementById('weight-unit');
    if (unitSelect) unitSelect.value = 'kg';

    // Hide results
    const resultsContainer = document.getElementById('shipping-results');
    if (resultsContainer) {
      resultsContainer.style.display = 'none';
    }

    // Show first step
    showStep(1);
    updateProgressBar(1);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    initCalculator();
  }

})();